/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-21 21:48:27
 * @LastEditTime: 2022-01-21 22:27:44
 * @LastEditors: zhao - 🍉
 * @Description: 设置客户自定义参数
 * @FilePath: /zhzj-admin/src/page/CustomerServices/CustomerList/components/DisplayTagModal.jsx
 */


import { message, Modal } from 'antd';
import React from 'react';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import Tags from '../../../../components/Tags';
import { fetchWechatServicesDispalyTagGet, fetchWechatServicesDispalyTagUpdate } from '../../../../services/wechatServices';

class DisplayTagModal extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      loading: false,
      customerData: {},
      tagList: []
    };
  }

    open = (customerData) => {
        this.setState({ visible: true, customerData });
        this.postGet({openId: customerData.openid, guideAccount: customerData.guide_account})
        return new Promise((resolve, reject) => {
            this.monitor = { resolve }
        })
    };

    close = () => {
        this.setState({ visible: false, tagList: [] });
    };

    postGet(data) {
        this.setState({ loading: true })
        fetchWechatServicesDispalyTagGet(data).then(res => {
            this.setState({ tagList: res })
        }).finally(() => {
            this.setState({ loading: false })
        })
    }
    postSubmit(data) {
        this.setState({ loading: true })
        
        return fetchWechatServicesDispalyTagUpdate(data).then(() => {
            message.success('保存成功')
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    handleTagChange(tags) {
        this.setState({ tagList: tags })
    }

    handleSubmit = () => {
        const data = {
            displayTagList: this.state.tagList,
            guideAccount: this.state.customerData.guide_account,
            guideOpenId: this.state.customerData.guide_openid,
            openId: this.state.customerData.openid,
        }
        this.postSubmit(data).then(() => {
            this.monitor.resolve()
            this.close()
        })
    }

    render() {
        return (
            <Modal 
                title="设置标签" 
                visible={this.state.visible} 
                confirmLoading={this.state.loading}
                onOk={this.handleSubmit}
                onCancel={this.close}
            >
                <ModalScrollContainer loading={this.state.loading}>
                    <Tags value={this.state.tagList || []} onChange={tags => this.handleTagChange(tags)} />
                </ModalScrollContainer>
            </Modal>
        );
    }
}

export default DisplayTagModal;


// WEBPACK FOOTER //
// ./src/page/CustomerServices/CustomerList/components/DisplayTagModal.jsx